export default __webpack_public_path__ + "static/media/books-480w.a210407d.avif";